import { accountingApi } from '../../../../config/apiClient';
import { ACCOUNTING_API } from '../../../../config/api';

export interface InventoryProductFeatureDto {
  id: string;
  companyId: string;
  name: string;
  branchesId?: string | null;
  orderIndex: number;
  isActive: boolean;
  createdAt: string;
  updatedAt?: string | null;
  valueCount: number;
}

export interface CreateInventoryProductFeatureDto {
  companyId?: string;
  name: string;
  branchesId?: string | null;
  orderIndex?: number;
  isActive?: boolean;
}

export interface UpdateInventoryProductFeatureDto {
  companyId?: string;
  id: string;
  name: string;
  branchesId?: string | null;
  orderIndex: number;
  isActive: boolean;
}

export interface InventoryItemFeatureValueDto {
  id: string;
  inventoryItemId: string;
  featureId: string;
  featureName: string;
  value?: string | null;
  orderIndex: number;
}

export interface SaveInventoryItemFeatureValueRowDto {
  featureId: string;
  value?: string | null;
  orderIndex: number;
}

export class ProductFeatureService {
  static async getAll(branchId?: string): Promise<InventoryProductFeatureDto[]> {
    try {
      const response = await accountingApi.get<InventoryProductFeatureDto[]>(
        ACCOUNTING_API.INVENTORY_PRODUCT_FEATURES,
        {
          params: branchId ? { branchId } : undefined,
        }
      );
      return response.data || [];
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Ek özellikler yüklenirken hata oluştu');
    }
  }

  static async getById(id: string): Promise<InventoryProductFeatureDto> {
    try {
      const response = await accountingApi.get<InventoryProductFeatureDto>(
        ACCOUNTING_API.INVENTORY_PRODUCT_FEATURE_BY_ID(id)
      );
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Ek özellik getirilirken hata oluştu');
    }
  }

  static async create(feature: CreateInventoryProductFeatureDto): Promise<InventoryProductFeatureDto> {
    try {
      const response = await accountingApi.post<InventoryProductFeatureDto>(
        ACCOUNTING_API.INVENTORY_PRODUCT_FEATURE_CREATE,
        {
          CompanyId: feature.companyId || '',
          Name: feature.name,
          BranchesId: feature.branchesId || null,
          OrderIndex: feature.orderIndex ?? 0,
          IsActive: feature.isActive ?? true,
        }
      );
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Ek özellik oluşturulurken hata oluştu');
    }
  }

  static async update(feature: UpdateInventoryProductFeatureDto): Promise<InventoryProductFeatureDto> {
    try {
      const response = await accountingApi.post<InventoryProductFeatureDto>(
        ACCOUNTING_API.INVENTORY_PRODUCT_FEATURE_UPDATE(feature.id),
        {
          CompanyId: feature.companyId || '',
          Id: feature.id,
          Name: feature.name,
          BranchesId: feature.branchesId || null,
          OrderIndex: feature.orderIndex,
          IsActive: feature.isActive,
        }
      );
      return response.data;
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Ek özellik güncellenirken hata oluştu');
    }
  }

  static async delete(id: string): Promise<void> {
    try {
      await accountingApi.post(ACCOUNTING_API.INVENTORY_PRODUCT_FEATURE_DELETE(id));
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Ek özellik silinirken hata oluştu');
    }
  }

  static async getValuesByItemId(itemId: string): Promise<InventoryItemFeatureValueDto[]> {
    try {
      const response = await accountingApi.get<InventoryItemFeatureValueDto[]>(
        ACCOUNTING_API.INVENTORY_ITEM_FEATURE_VALUES(itemId)
      );
      return response.data || [];
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Ürün özellik değerleri yüklenirken hata oluştu');
    }
  }

  static async saveValuesForItem(itemId: string, values: SaveInventoryItemFeatureValueRowDto[]): Promise<void> {
    try {
      await accountingApi.post(
        ACCOUNTING_API.INVENTORY_ITEM_FEATURE_VALUES(itemId),
        {
          InventoryItemId: itemId,
          Values: values.map(v => ({
            FeatureId: v.featureId,
            Value: v.value || null,
            OrderIndex: v.orderIndex,
          })),
        }
      );
    } catch (error: any) {
      throw new Error(error.response?.data?.message || 'Ürün özellik değerleri kaydedilirken hata oluştu');
    }
  }
}
